import React from "react";
import StatusBadge from "src/components/StatusBadgeV2/StatusBadgeV2";
import { formatUSD } from "src/util/utils.currency";
import * as S from "../../constants/StringConstants";
import { formatDate } from "../CampaignDetail/utils";
import { ApplicationActions } from "./ApplicationActions";

const specialistColumn = (title: string) => ({
  key: "uwSpecialist",
  title,
  style: { minWidth: "10rem" },
  sortKey: "UwSpecialist",
});

const applicationColumns = {
  name: { key: "name", title: S.APP_COL_NAME, style: { minWidth: "20rem" }, sortKey: "Name" },
  policyNumber: {
    key: "policyNumber",
    title: S.APP_COL_POLICY_NUM,
    style: { minWidth: "15rem" },
    sortKey: "PolicyNumber",
  },
  carrier: { key: "carrier", title: S.APP_COL_CARRIER, style: { minWidth: "10rem" }, sortKey: "Carrier" },
  review: {
    key: "reviewDate",
    title: S.APP_COL_REVIEW_DATE,
    style: { minWidth: "10rem" },
    sortKey: "ReviewDate",
    render: item => formatDate(item.reviewDate),
  },
  product: { key: "product", title: S.APP_COL_PRODUCT, style: { minWidth: "15rem" }, sortKey: "Product" },
  specialist: specialistColumn(S.APP_COL_SPECIALIST),
  uwSpecialist: specialistColumn(S.APP_COL_UW_SPECIALIST),
  branch: { key: "branch", title: S.APP_COL_BRANCH, style: { minWidth: "10rem" }, sortKey: "Branch" },
  agent: { key: "primaryAgent", title: S.APP_COL_AGENT, style: { minWidth: "15rem" }, sortKey: "PrimaryAgent" },
  premium: {
    key: "premium",
    title: S.APP_COL_PREMIUM,
    style: { minWidth: "5rem" },
    sortKey: "Premium",
    render: item => formatUSD(item.premium, 2),
  },
  status: {
    key: "status",
    title: S.APP_COL_STATUS,
    render: item => <StatusBadge status={item.status} />,
    style: { minWidth: "5rem" },
    sortKey: "Status",
  },
};

export const applicationsPageColumns = (handleDelete?: (id: string) => void) => [
  ...[
    applicationColumns.name,
    applicationColumns.policyNumber,
    applicationColumns.carrier,
    applicationColumns.review,
    applicationColumns.product,
    applicationColumns.specialist,
    applicationColumns.branch,
    applicationColumns.agent,
    applicationColumns.status,
  ],
  ...(handleDelete
    ? [
        {
          key: "actions",
          title: S.APP_COL_ACTIONS,
          render: item => <ApplicationActions application={item} handleDelete={handleDelete} />,
        },
      ]
    : []),
];

export const brokersApplicationsPageColumns = [
  ...[
    applicationColumns.name,
    applicationColumns.policyNumber,
    applicationColumns.carrier,
    applicationColumns.product,
    applicationColumns.uwSpecialist,
    applicationColumns.branch,
    applicationColumns.premium,
    applicationColumns.status,
  ],
];
